module.exports = __webpack_public_path__ + "assets/img/trait4.ddf48c54.png";